import {initMainHeader} from '../js/src/header-init';
import '../scss/pages/search-default.scss';

initMainHeader();
